import React, { useState, useEffect } from "react";
import axios from 'axios';
import './../styles/default.css';
import './../styles/login.css';
import Logo from './../components/logo_black.png'
import * as globals from './../components/GlobalScripts.js';
import { useParams, Link, useNavigate } from 'react-router-dom';

import banner1 from './../components/login/banner1.png';

const Configure_account = () => {
    let path_api = localStorage.getItem('path_api');
    const navigate = useNavigate();
    const { id } = useParams();
    const [formDataAccount, setFormDataAccount] = useState({});

    useEffect(() => {
        get_user();
    }, [id]);

    const get_user = () => {
        globals.openViewCharge();
        axios.post(`${path_api}/default/configure_account.php`, {
            id_sms: id
        }).then(response => {
            if (response.data.mensaje === 'success') {
                setFormDataAccount(response.data.account);
            }else if (response.data.mensaje === 'Cuenta en uso') {
                globals.createAlert({
                    type: "advertencia",
                    msg_title: "Acción no requerida",
                    msg: "La cuenta ya fue configurada",
                    effect: "opacidad 2s, desplazamiento 2s"
                });
                navigate('/login');
            } else {
                globals.createAlert({
                    type: "error",
                    msg_title: "Error",
                    msg: response.data.mensaje || "No se obtuvo la cuenta, contacta a soporte",
                    effect: "opacidad 2s, desplazamiento 2s"
                });
            }
        }).catch(error => {
            globals.createAlert({
                type: "error",
                msg_title: "Error",
                msg: "Error al cargar la cuenta, contacta a soporte",
                effect: "opacidad 2s, desplazamiento 2s"
            });
        }).finally(() => {
            globals.closeViewCharge();
        });
    };

    const configureAccount = () => {
        globals.openViewCharge();
        axios.post(`${path_api}/default/configure_end.php`, {
            id_sms: id,
            account: formDataAccount
        }).then(response => {
            if (response.data.mensaje === 'success') {
                globals.createAlert({
                    type: "success",
                    msg_title: "Exito",
                    msg: "Cuenta configurada",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
                navigate('/login?email=' + formDataAccount.email);
            } else {
                globals.createAlert({
                    type: "error",
                    msg_title: "Error",
                    msg: response.data.mensaje || "La cuenta no se configuro",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
            }
        }).catch(error => {
            globals.createAlert({
                type: "error",
                msg_title: "Error",
                msg: "Error al conectar con el servidor",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4000
            });
        }).finally(() => {
            globals.closeViewCharge();
        });
    };

    const handleSubmit_account = async (e) => {
        e.preventDefault();
        configureAccount();
    };

    const handleChange_account = (e) => {
        const { name, type, checked, value } = e.target;
        const newValue = type === "checkbox" ? checked : value;
        setFormDataAccount({ ...formDataAccount, [name]: newValue });
    };

    if(!formDataAccount?.email) return null;

    return (
        <>
            <div className="app-default app-container">
                <div className="main-content page-login">
                    <div className="page-container">
                        <div className="section-capture-data">
                            <div className="banner" style={{ backgroundImage: `url(${banner1})` }}></div>
                            <div className="capture-data">
                                <Link to="/">
                                    <img src={Logo} className="logo"></img>
                                </Link>
                                <div>
                                    <form onSubmit={handleSubmit_account} className="flex-column gap-20">
                                        <h2>Termina de configurar tu cuenta</h2>

                                        <div className="form-group">
                                            <label htmlFor="email">Email</label>
                                            <input
                                                type="email"
                                                id="email"
                                                name="email"
                                                value={formDataAccount.email}
                                                onChange={handleChange_account}
                                                className="input-primary"
                                                placeholder="ejemplo@ejemplo.com"
                                                readOnly
                                                required
                                            />
                                        </div>

                                        <div className="form-group">
                                            <label htmlFor="pass">Contraseña</label>
                                            <input
                                                type="password"
                                                id="pass"
                                                name="pass"
                                                value={formDataAccount.pass}
                                                onChange={handleChange_account}
                                                className="input-primary"
                                                placeholder="****"
                                                required
                                            />
                                        </div>

                                        <div className="form-group">
                                            <label htmlFor="confirm_pass">Confirmar contraseña</label>
                                            <input
                                                type="password"
                                                id="confirm_pass"
                                                name="confirm_pass"
                                                value={formDataAccount.confirm_pass}
                                                onChange={handleChange_account}
                                                className="input-primary"
                                                placeholder="****"
                                                required
                                            />
                                        </div>

                                        <div className="form-group">
                                                <label htmlFor="terms">
                                                    <input
                                                        type="checkbox"
                                                        id="terms"
                                                        name="terms"
                                                        checked={formDataAccount.terms}
                                                        onChange={handleChange_account}
                                                        className="input-primary"
                                                        required
                                                    />
                                                    Acepto los <a href="/terminos-condiciones" target="_blank" rel="noopener noreferrer">Términos y Condiciones</a>
                                                </label>
                                            </div>

                                        <button className="button-primary" type="submit">Terminar</button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Configure_account;